import { render } from "./AdminsView.vue?vue&type=template&id=97a464ce"
import script from "./AdminsView.vue?vue&type=script&lang=js"
export * from "./AdminsView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__